<template>
  <closeable-tag :active="active" @close="$emit('close')" @open="$emit('open')">
    <vote-topic-icon class="mr-1" :topic="theme" />
    <span class="truncate">{{ theme.name }}</span>
  </closeable-tag>
</template>

<script>
import VoteTopicIcon from "../vote/VoteTopicIcon.vue";
import CloseableTag from "./CloseableTag.vue";

export default {
  name: "CloseableThemeTag",
  components: {
    CloseableTag,
    VoteTopicIcon
  },
  props: {
    active: {
      type: Boolean,
      default: true
    },
    theme: {}
  }
};
</script>
